export default __webpack_public_path__ + "static/media/login-bg-32.f705bae6.jpg";